import React from 'react'

function Contact() {
    return (
      <section className="text-gray-700 body-font relative" id="contact">
      <div className="container px-5 py-24 mx-auto">
        <div className="flex flex-col text-center w-full mb-12">
          <h1 className="sm:text-5xl text-2xl font-medium title-font mb-4 text-gray-900">Let's create experiences together</h1>
          <p className="lg:w-2/3 mx-auto leading-relaxed text-lg"> I am Open for all types of <span className="font-medium text-indigo-500"> Development and</span> Projects <br/> If you want to collab or just talk <br/> Mail me at : <a className="text-indigo-500" href="mailto:tripathiabhishek877@gmail.com">tripathiabhishek877@gmail.com</a></p>
        </div>
      </div>
    </section>
    )
}

export default Contact;
